import React, { useState } from "react";

const CustomHeader = ({
  previousPage,
  nextPage,
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  gotoPage,
  doSearch,
  initialSearchQuery,
  showGotoPage = true,
  showSuperJump = true,
}) => {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  return (
    <div className="flex items-center">
      {showSuperJump && (
        <button
          type="button"
          className="btn p-1 w-10 mx-1"
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        >
          {"<<"}
        </button>
      )}
      <button
        type="button"
        className="btn p-1 w-10 mx-1"
        onClick={() => previousPage()}
        disabled={!canPreviousPage}
      >
        {"<"}
      </button>
      <button
        type="button"
        className="btn p-1 w-10 mx-1"
        onClick={() => nextPage()}
        disabled={!canNextPage}
      >
        {">"}
      </button>
      {showSuperJump && (
        <button
          type="button"
          className="btn p-1 w-10 mx-1"
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          {">>"}
        </button>
      )}
      <p className="ml-3 mr-6">
        Page{" "}
        {showGotoPage ? (
          <input
            className="p-1 w-10"
            value={pageIndex + 1}
            onChange={(e) => gotoPage(e.target.value - 1)}
            onClick={(e) => e.target.select()}
          />
        ) : (
          <span>{pageIndex + 1}</span>
        )}{" "}
        of {pageCount}
      </p>
      <p>
        Search:{" "}
        <input
          className="p-1"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => (e.key == "Enter" ? doSearch(searchQuery) : 0)}
        />
      </p>
      <button
        type="button"
        className="btn p-1 w-10 mx-1"
        onClick={() => doSearch(searchQuery)}
      >
        go
      </button>
      {/* {!!globalFilter && (
        <button
          type="button"
          className="btn p-1 mx-1"
          onClick={() => {
            setSearchQuery("");
            setGlobalFilter("");
          }}
        >
          clear
        </button>
      )} */}
    </div>
  );
};

export default CustomHeader;
